const c = {
  name: "Github",
  dimensions: { width: 40, height: 39 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 39" style="enable-background:new 0 0 40 39;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.9,0C8.9,0,0,8.9,0,20c0,8.8,5.7,16.3,13.6,19c1,0.1,1.3-0.5,1.3-1c0-0.5,0-1.7,0-3.4
			c-5.5,1.2-6.7-2.7-6.7-2.7C7.3,29.5,6,28.9,6,28.9c-1.8-1.2,0.1-1.2,0.1-1.2c2,0.1,3.1,2.1,3.1,2.1c1.8,3.1,4.6,2.2,5.7,1.7
			c0.1-1.3,0.7-2.2,1.2-2.7c-4.4-0.5-9.1-2.2-9.1-9.9c0-2.2,0.7-3.9,2.1-5.4C9.1,13.1,8.3,11,9.4,8.3c0,0,1.7-0.5,5.5,2.1
			c1.6-0.5,3.3-0.6,5-0.6c1.7,0,3.4,0.2,5,0.6c3.8-2.6,5.5-2.1,5.5-2.1c1.1,2.7,0.4,4.8,0.2,5.3c1.2,1.3,2.1,3.2,2.1,5.4
			c0,7.7-4.6,9.3-9.1,9.8c0.7,0.6,1.3,1.8,1.3,3.7c0,2.7,0,4.8,0,5.5c0,0.5,0.4,1.1,1.3,1c8-2.7,13.6-10.2,13.6-19
			C39.9,8.9,30.9,0,19.9,0z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Github
};
